import {
  SHStack,
  SHTableCell,
  SHTableHead,
  SHTableRow,
  SHTypography,
} from "@components/design-systems";
import { SelectedProductDTO } from "@models/platform-analysis/entities/steps/feature";
import { memo } from "react";
import { AnalysisSummaryStyleConfigs as StyleConfigs } from "../../../../configs";
import { SummaryAnalysisTableProductHeaderCell } from "../../rendered-cells/product-logo";

interface SummaryAnalysisTableHeadProps {
  isReview?: boolean;
  selectedProducts?: SelectedProductDTO[];
}
export const SummaryAnalysisTableHead = memo(
  ({ isReview, selectedProducts }: SummaryAnalysisTableHeadProps) => {
    return (
      <SHTableHead>
        <SHTableRow>
          <SHTableCell
            className="SummaryAnalysisTableHead-Title"
            sx={{ padding: "0px !important" }}
          >
            <SHStack
              sx={{
                position: "sticky",
                left: 0,
                height: "100%",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                zIndex: 10,
              }}
            >
              <SHTypography
                variant={"subtitle1"}
                lineHeight={"150%"}
                sx={{
                  fontWeight: 700,
                }}
              >
                Platforms
              </SHTypography>
            </SHStack>
          </SHTableCell>

          <SHTableCell
            className="SummaryAnalysisTableHead-TotalSelections"
            sx={{ padding: "0px !important" }}
          >
            <SHStack
              minWidth={StyleConfigs.TotalFeaturesSelectedColumnWidth}
              maxWidth={StyleConfigs.TotalFeaturesSelectedColumnWidth}
              paddingX={"0px !important"}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <SHTypography
                variant="caption"
                sx={{
                  fontWeight: 700,
                  lineHeight: "150%",
                  textAlign: "center",
                }}
              >
                Selections /<br /># Available
              </SHTypography>
            </SHStack>
          </SHTableCell>

          {selectedProducts?.map((product, productIndex) => (
            <SHTableCell
              className="SummaryAnalysisTableHead-Product"
              key={productIndex}
              sx={{ padding: "0px !important" }}
            >
              <SummaryAnalysisTableProductHeaderCell
                product={product}
                isReview={isReview}
              />
            </SHTableCell>
          ))}
        </SHTableRow>
      </SHTableHead>
    );
  },
);
